export default __webpack_public_path__ + "static/media/subash.c6b3aa4b.png";